export default __webpack_public_path__ + "static/media/2010.a3f3214b.jpg";